import { graphql } from '@/gql'

export const CustomFieldListFragment = graphql(/* GraphQL */ `
  fragment CustomFieldList on CustomField {
    id
    title
    slug
    appliesTo
    approval
    apiOnly
    workerInputAllowed
    workerInputStage
    recruiterInputAllowed
    recruiterInputStage
    showOnInvoice
    sharedWithClients
    sharedWithStaffingAgencies
    visibility
    fieldType
    settings {
      validation
    }
    user {
      id
      name
      email
    }
    isUsedInFieldValues
    viewerCanUpdate
    updatedAt
    createdAt
    archivedAt
  }
`)

export const CustomFieldDetailFragment = graphql(/* GraphQL */ `
  fragment CustomFieldDetail on CustomField {
    id
    title
    slug
    description
    visibility
    approval
    apiOnly
    workerInputAllowed
    workerInputStage
    recruiterInputAllowed
    recruiterInputStage
    showOnInvoice
    sharedWithClients
    sharedWithStaffingAgencies
    fieldType
    appliesTo
    settings {
      ...CustomFieldSettings
    }
    isUsedInFieldValues
    viewerCanUpdate
    customFieldOptions {
      ...CustomFieldOption
    }
    user {
      id
      name
      email
    }
    createdAt
    updatedAt
    archivedAt
    ...CustomFieldForFieldableValidation
  }
`)

export const CustomFieldForFieldableValidationFragment = graphql(/* GraphQL */ `
  fragment CustomFieldForFieldableValidation on CustomField {
    id
    title
    settings {
      ...CustomFieldSettings
    }
  }
`)

export const CustomFieldSettingsFragment = graphql(/* GraphQL */ `
  fragment CustomFieldSettings on CustomFieldSettings {
    validation
  }
`)

export const CustomFieldOptionFragment = graphql(/* GraphQL */ `
  fragment CustomFieldOption on CustomFieldOption {
    id
    value
    displayOrder
    removalBlockedBy
  }
`)
